import { RootState, AzureAdStatus } from "./types";
import { ActionContext } from "vuex";
import { getAzureAdStatus } from "@/services/security/authService";
import { getApplicationSettings } from "@/services/applicationSettings/applicationSettingsService";
import { ApplicationSettings } from "@/services/applicationSettings/types";

export default {
    reload({ commit }: ActionContext<RootState, any>) {
        commit("reload");
    },
    loadAzureAdStatus({ commit }: ActionContext<RootState, any>) {
        return new Promise((resolve, reject) => {
            getAzureAdStatus()
                .then((response: AzureAdStatus) => {
                    commit("loadAzureAdStatusSuccess", response);
                    resolve(response);
                })
                .catch(reason => {
                    reject(reason);
                });
        });
    },
    loadAllowStockImages({ commit }: ActionContext<RootState, any>) {
        return new Promise((resolve, reject) => {
            getApplicationSettings({ keys: ["AllowStockImages"] })
                .then((response: ApplicationSettings) => {
                    commit("updateAllowStockImages", response.allowStockImages);
                    resolve(response);
                })
                .catch(reason => {
                    reject(reason);
                });
        });
    }
};
